
import { defineComponent } from 'vue';

import EpicContentSplash from './epic-content-splash.vue';
import EpicContentTimeline from './epic-content-timeline.vue';

import { epicContentComposition } from '../services';

export default defineComponent({
	components: {
		EpicContentSplash,
        EpicContentTimeline
	},
    setup () {
        return { ...epicContentComposition() }
    }
})
